const Main = () => import('../../pages/main')
export default {
	path: '/coupon',
	component: Main,
	meta: {
		sideNav: true
	},
	children: [
		{
			name: 'coupon',
			path: 'index',
			component: () => import('../../pages/Coupon'),
			meta: {
				requiresAuth: true,
				hidden: false,
				title: '课 程 券 ',
				icon: 'icon-nav icon-nav-coupon'
			}
		}
	]
}
